/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/Logo2.jpg";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (selector: string) => {
    const targetElement = document.querySelector(selector);
    const offset = 80;

    if (targetElement) {
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
      setMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 bg-[rgb(25,24,31)] text-white flex justify-between items-center p-4 z-50 shadow-md">
      {/* Logo */}
      <div className="flex items-center ml-4">
        <img src={logo} alt="Logo de Glowin" className="h-24" />
      </div>

      {/* hamburg. menu */}
      <div className="lg:hidden">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-white text-2xl focus:outline-none"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <nav className="hidden lg:flex xl:flex absolute left-1/2 transform -translate-x-1/2 flex gap-14">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("body");
          }}
          className="py-2 px-4 bg-white text-black rounded-full font-semibold hover:bg-gray-200 transition-colors duration-300"
        >
          Inicio
        </a>
        <a
          href="#pricing-plans"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#pricing-plans");
          }}
          className="py-2 px-4 bg-white text-black rounded-full font-semibold hover:bg-gray-200 transition-colors duration-300"
        >
          Soluciones a Domicilio
        </a>
        <a
          href="#trabaja-con-nosotros"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#trabaja-con-nosotros");
          }}
          className="py-2 px-4 bg-white text-black rounded-full font-semibold hover:bg-gray-200 transition-colors duration-300"
        >
          Trabaja con Nosotros
        </a>
      </nav>

      {/* Botón Call-to-Action */}
      <a
        href="#contact"
        onClick={(e) => {
          e.preventDefault();
          scrollToSection("#contact");
        }}
        className="hidden lg:inline-block xl:inline-block py-4 px-4 bg-yellow-500 text-black rounded-full font-semibold hover:bg-yellow-400 transition-colors duration-300 mr-8"
      >
        Contactanos
      </a>

      {/* Menú desplegable para móviles */}
      {menuOpen && (
        <div className="fixed inset-0 bg-[rgb(25,24,31)] text-white flex flex-col justify-center items-center gap-8 z-50 xl:hidden">
          <button
            onClick={() => setMenuOpen(false)}
            className="absolute top-4 right-4 text-3xl text-white focus:outline-none"
          >
            <FaTimes />
          </button>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("body");
            }}
            className="text-2xl font-semibold hover:text-yellow-500 transition-colors duration-300"
          >
            Inicio
          </a>
          <a
            href="#pricing-plans"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#pricing-plans");
            }}
            className="text-2xl font-semibold hover:text-yellow-500 transition-colors duration-300"
          >
            Soluciones a Domicilio
          </a>
          <a
            href="#trabaja-con-nosotros"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#trabaja-con-nosotros");
            }}
            className="text-2xl font-semibold hover:text-yellow-500 transition-colors duration-300"
          >
            Trabaja con Nosotros
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#contact");
            }}
            className="text-2xl font-semibold hover:text-yellow-500 transition-colors duration-300"
          >
            Contactanos
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
